/**
 * 快手搜索渠道 query 参数跨子域名共享工具
 * 用于 a.9fzt.com、b.9fzt.com、www.9fzt.com 等子域名间共享 from=kuaishou_search 状态
 */
console.log('process.env.NODE_ENV ',process.env.NODE_ENV === 'dev')

const COOKIE_NAME = 'ks_query'
const COOKIE_DOMAIN = process.env.NODE_ENV === 'dev' ? '' : '.9fzt.com'
const COOKIE_EXPIRE_DAYS = 1

/**
 * 设置 Cookie
 */
function setCookie(cname, cvalue, exdays) {
  const date = new Date()
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + date.toGMTString()
  const domainPart = COOKIE_DOMAIN ? `;domain=${COOKIE_DOMAIN}` : ''
  document.cookie = `${cname}=${encodeURIComponent(cvalue)};${expires};path=/${domainPart}`
}

/**
 * 读取 Cookie
 */
function getCookie(cname) {
  const name = cname + '='
  const ca = document.cookie.split(';')
  console.log('getCookie',ca)
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(name) === 0) {
      return decodeURIComponent(c.substring(name.length))
    }
  }
  return ''
}

/**
 * 解析 query 字符串为对象
 */
function parseQuery(queryStr) {
  if (!queryStr) return {}
  const query = queryStr.startsWith('?') ? queryStr.slice(1) : queryStr
  const params = {}
  query.split('&').forEach(pair => {
    const [key, value] = pair.split('=')
    if (key) {
      params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : ''
    }
  })
  return params
}

/**
 * 初始化快手 query 共享
 * - 如果当前 URL 有 from=kuaishou_search，保存到 cookie
 * - 如果当前 URL 没有，从 cookie 读取
 */
export function initKuaishouQuery() {
  const currentQuery = window.location.search
  const queryParams = parseQuery(currentQuery)
  
  if (queryParams.from === 'kuaishou_search') {
    // 当前页面有快手渠道参数，保存到 Cookie
    setCookie(COOKIE_NAME, currentQuery, COOKIE_EXPIRE_DAYS)
  }
}

/**
 * 判断是否为快手搜索渠道
 * 优先从当前 URL 判断，其次从 cookie 读取
 */
export function isKuaishouSearch(routeQuery) {
  // 优先使用路由 query
  if (routeQuery && routeQuery.from === 'kuaishou_search') {
    return true
  }
  
  // 从 cookie 读取
  const savedQuery = getCookie(COOKIE_NAME)
  if (savedQuery) {
    const params = parseQuery(savedQuery)
    return params.from === 'kuaishou_search'
  }
  
  return false
}

/**
 * 获取快手渠道的完整 query 参数
 * 优先从当前 URL 获取，其次从 cookie 读取
 */
export function getKuaishouQuery(routeQuery) {
  // 优先使用路由 query
  if (routeQuery && routeQuery.from === 'kuaishou_search') {
    return routeQuery
  }
  
  // 从 cookie 读取
  const savedQuery = getCookie(COOKIE_NAME)
  if (savedQuery) {
    return parseQuery(savedQuery)
  }
  
  return {}
}

export default {
  initKuaishouQuery,
  isKuaishouSearch,
  getKuaishouQuery
}
